<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<form
			class="h-full flex flex-col"
			@submit.prevent="tryGotoStepIfFormValid(step + 1)"
		>
			<!-- header title -->
			<div class="bg-green-500 px-6 py-4 text-white relative">
				<div class="flex justify-between items-baseline pr-4 mr-6">
					<h1 class="text-4xl font-bold">
						<span v-if="locale == 'de'">Offerieren auf Tagespreis</span>
						<span v-else>Offer on daily price</span>
					</h1>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<div class="min-h-[30rem] flex flex-col">
				<ui-alert-errors
					v-if="otherErrorMessages.length > 0"
					:messages="otherErrorMessages"
					class="border-b border-red-300 rounded-none"
				/>

				<div class="overflow-y-auto">
					<bid-edit-step-1-price-indication
						v-if="step == 1"
						:form="form"
						:counterpart="counterpart"
						:reference="reference"
						:match="match"
						:iframe-modal="iframeModal"
						:trade="trade"
						:lastDisplayedPrice="lastDisplayedPrice"
						:active-futures="activeFutures"
						:other-errors="otherErrors"
						:show-reference="false"
						v-on:tryGotoStepIfFormValid="tryGotoStepIfFormValid(step + 1)"
					/>

					<bid-edit-step-2
						v-if="step == 2"
						:form="form"
						:trade="trade"
						:active-futures="activeFutures"
						:reference="null"
					/>
				</div>

				<div class="bg-gray-100 p-6 flex justify-between" v-if="step == 2">
					<div>
						<ui-button
							type="secondary"
							v-if="step == 2"
							v-on:click="step--"
							label="Back"
						/>
					</div>
					<div>
						<ui-button
							type="primary"
							v-if="step == 1"
							v-on:click="tryGotoStepIfFormValid(step + 1)"
							label="Continue"
						/>
						<ui-button
							v-else-if="step == 2"
							type="primary"
							:disabled="submitButtonDisabled"
							v-on:click="submitForm()"
							label="Offer"
						></ui-button>
					</div>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		bid: {
			type: Object,
			required: true,
		},
		counterpart: {
			type: Object,
			required: true,
		},
		reference: {
			type: Object,
			required: true,
		},
		match: {
			type: Object,
			required: false,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		trade: {
			type: String,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		user: {
			type: Object,
			required: true,
		},
		lastDisplayedPrice: {
			type: String,
			required: false,
		},
		priceIndication: {
			type: Object,
			required: false,
		},
	},
	data() {
		this.bid.price.mt = this.lastDisplayedPrice;
		return {
			form: Vue.observable(this.$inertia.form(this.bid)),
			step: 1,
		};
	},
	computed: {
		otherErrorMessages() {
			return Object.values(this.otherErrors || {});
		},
	},
};
</script>
